import Icon from './Icon'
import styled from 'react-emotion'
import Title from './Title'
import { prop } from 'utils/fp'
import { spacer } from 'stylist'

const PageHeader = styled.header`
  display: grid;
  align-items: center;
  grid-template-columns: ${prop('columns')};
  grid-gap: ${spacer(2)};
  grid-auto-flow: column;
  grid-auto-columns: auto;
`

PageHeader.Title = Title
PageHeader.Icon = Icon

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js